import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { Base64UrlService } from '../../../services/base64url.service';

@Component({
  selector: 'tt-ftp-account',
  templateUrl: './ftp-account.component.html',
  styleUrls: ['./ftp-account.component.css']
})
export class FtpAccountComponent implements OnInit {
    public ftpAccountKeyno: string;

    public edit?: Edit;

    public saving = false;

    public deleting = false;

    constructor(private stateService: StateService, private base64: Base64UrlService, private modal: ModalService, private datatask: DataTaskService) {
        this.ftpAccountKeyno = this.stateService.getStateParams()['ftpaccount_keyno'];
    }

    private async loadEdit() {
        if (!!this.ftpAccountKeyno) {
            this.edit = (await this.datatask.Post(969, { ftpaccount_keyno: this.ftpAccountKeyno }))[0];

            if (!!this.edit) {
                this.edit.remotepass = this.base64.urlDecode(this.edit.remotepass);
                this.edit.remotefolder = this.base64.urlDecode(this.edit.remotefolder);
                this.edit.localfolder = this.base64.urlDecode(this.edit.localfolder);
            }
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                await this.datatask.Post(970, this.edit);

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    public async deleteValues() {
        if (!!this.edit) {
            try {
                this.deleting = true;

                const deleteConfirmed = await this.modal.openConfirmDialog({
                    title: 'confirm_title',
                    translateMessage: true,
                    message: 'confirm_message',
                    type: 'danger'
                });

                if (deleteConfirmed) {
                    await this.datatask.Post(971, this.edit);

                    this.stateService.back();
                }
            } finally {
                this.deleting = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    ftpaccount_keyno: number;
    ftpaccount_name: string;
    sftp: number;
    remotehost: string;
    remoteuser: string;
    remotepass: string;
    remotefolder: string;
    remoteport: string;
    localfolder: string;
    isactive: number;
    deleteremote: number;
    uselist: number;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('ftpAccount', {
//        templateUrl: 'views/components/views/ftpAccount/ftpAccount.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'ftpAccountService', function ($stateParams, stateService, translateService, modalService, ftpAccountService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let ftpAccountKeyno = $stateParams.ftpaccount_keyno;

//            let translations = {
//                confirm_title: '',
//                confirm_message: '',
//                confirm_ok_label: '',
//                confirm_cancel_label: '',
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                ftpAccountKeyno: ftpAccountKeyno,
//                edit: {},
//                lockedSave: false,
//                lockedDelete: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION SERVICE

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION SERVICE

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await ftpAccountService.getEdit({ ftpaccount_keyno: ftpAccountKeyno }))[0];

//                vm.model.edit.remotepass = atob(vm.model.edit.remotepass);
//                vm.model.edit.remotefolder = atob(vm.model.edit.remotefolder);
//                vm.model.edit.localfolder = atob(vm.model.edit.localfolder);
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                ftpAccountService.saveObj(vm.model.edit).then(function () {
//                    vm.model.lockedSave = false;
//                    stateService.back();
//                }, function () {
//                    vm.model.lockedSave = false;
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region BUTTON DELETE PROCEDURE FUNCTION CALL

//            vm.deleteValues = function () {
//                vm.model.lockedDelete = true;

//                modalService.confirm({
//                    type: 'danger',
//                    title: translations.confirm_title,
//                    message: translations.confirm_message,
//                    okLabel: translations.confirm_ok_label,
//                    cancelLabel: translations.confirm_cancel_label
//                }).then(function () {
//                    ftpAccountService.deleteItem(vm.model.edit).then(function () {
//                        vm.model.lockedDelete = false;
//                        stateService.back();
//                    }, function () {
//                        vm.model.lockedDelete = false;
//                    });
//                }, function () {
//                    vm.model.lockedDelete = false;
//                });
//            };

//            // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadEdit();
//            };

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
